"use strict";
// Copied from: https://github.com/rveciana/svg-path-properties
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBezier = void 0;
const bezier_functions_1 = require("./bezier-functions");
const makeBezier = ({ ax, ay, bx, by, cx, cy, dx, dy, }) => {
    let d;
    let getArcLength;
    let getPoint;
    let getDerivative;
    const a = { x: ax, y: ay };
    const b = { x: bx, y: by };
    const c = { x: cx, y: cy };
    if (dx !== null && dy !== null) {
        getArcLength = bezier_functions_1.getCubicArcLength;
        getPoint = bezier_functions_1.cubicPoint;
        getDerivative = bezier_functions_1.cubicDerivative;
        d = { x: dx, y: dy };
    }
    else {
        getArcLength = bezier_functions_1.getQuadraticArcLength;
        getPoint = bezier_functions_1.quadraticPoint;
        getDerivative = bezier_functions_1.quadraticDerivative;
        d = { x: 0, y: 0 };
    }
    const length = getArcLength([a.x, b.x, c.x, d.x], [a.y, b.y, c.y, d.y], 1);
    const getTotalLength = () => {
        return length;
    };
    const getPointAtLength = (len) => {
        const xs = [a.x, b.x, c.x, d.x];
        const xy = [a.y, b.y, c.y, d.y];
        const t = (0, bezier_functions_1.t2length)(len, len, (i) => getArcLength(xs, xy, i));
        return getPoint(xs, xy, t);
    };
    const getTangentAtLength = (len) => {
        const xs = [a.x, b.x, c.x, d.x];
        const xy = [a.y, b.y, c.y, d.y];
        const t = (0, bezier_functions_1.t2length)(len, len, (i) => getArcLength(xs, xy, i));
        const derivative = getDerivative(xs, xy, t);
        const mdl = Math.sqrt(derivative.x * derivative.x + derivative.y * derivative.y);
        let tangent;
        if (mdl > 0) {
            tangent = { x: derivative.x / mdl, y: derivative.y / mdl };
        }
        else {
            tangent = { x: 0, y: 0 };
        }
        return tangent;
    };
    const getPropertiesAtLength = (len) => {
        const xs = [a.x, b.x, c.x, d.x];
        const xy = [a.y, b.y, c.y, d.y];
        const t = (0, bezier_functions_1.t2length)(len, len, (i) => getArcLength(xs, xy, i));
        const derivative = getDerivative(xs, xy, t);
        const mdl = Math.sqrt(derivative.x * derivative.x + derivative.y * derivative.y);
        let tangent;
        if (mdl > 0) {
            tangent = { x: derivative.x / mdl, y: derivative.y / mdl };
        }
        else {
            tangent = { x: 0, y: 0 };
        }
        const point = getPoint(xs, xy, t);
        return { x: point.x, y: point.y, tangentX: tangent.x, tangentY: tangent.y };
    };
    const getC = () => {
        return c;
    };
    const getD = () => {
        return d;
    };
    return {
        getPointAtLength,
        getPropertiesAtLength,
        getTangentAtLength,
        getTotalLength,
        getC,
        getD,
    };
};
exports.makeBezier = makeBezier;
